var map = {
	"./Messages.jpg": 631,
	"./Messages.png": 428,
	"./book.png": 632,
	"./box.png": 633,
	"./chat.png": 634,
	"./chat_01.png": 635,
	"./chat_02.png": 636,
	"./chat_icon.png": 637,
	"./cloud.png": 429,
	"./dashboard.png": 638,
	"./dot.png": 639,
	"./get_started_bg.png": 640,
	"./john.png": 430,
	"./left_leaf.png": 431,
	"./live_chat.png": 432,
	"./mobile.png": 641,
	"./panguin_img_one.png": 433,
	"./panguin_img_three.png": 434,
	"./panguin_img_two.png": 435,
	"./pluse.png": 642,
	"./richard.png": 436,
	"./right_leaf.png": 437,
	"./skyp_1.png": 643,
	"./skyp_2.png": 644,
	"./support_dashboard.jpg": 645,
	"./triangle.png": 646,
	"./video_icon.png": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;